import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react'
import type { SortDir } from '../utils/tableSort'

export function SortableHeader({
  label,
  field,
  sortKey,
  sortDir,
  onSort,
}: {
  label: string
  field: string
  sortKey: string
  sortDir: SortDir
  onSort: (field: string) => void
}) {
  const active = sortKey === field
  return (
    <th className="px-4 py-3">
      <button
        type="button"
        onClick={() => onSort(field)}
        className="inline-flex items-center gap-1 uppercase tracking-wide hover:text-slate-700"
      >
        {label}
        {active ? (
          sortDir === 'asc' ? (
            <ArrowUp className="h-3 w-3" />
          ) : (
            <ArrowDown className="h-3 w-3" />
          )
        ) : (
          <ChevronsUpDown className="h-3 w-3 text-slate-400" />
        )}
      </button>
    </th>
  )
}
